'use client';

import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import { Text } from '@/shared/ui';
import { useModal } from '@/features/Modals';
/*In case of custom logic made override for SupplyInput here*/
import { SupplyInput } from '@/widgets/Modals';
import { useMaxBalance } from '@/features/Modals/ui/MarginAccountVaultModals/Supply/hooks/useMaxBalance';

type SupplyInputProps = {
    value: string;
    name: string;
    setValue: (value: string | null) => void;
    userBalance: string;
    tokenSymbol: string;
    poolBalance: string;
    disabled: boolean;
    decimals: number;
    totalDeposited?: string;
    totalDepositThreshold?: string;
};

type SupplyAmountFieldProps = {
    name: string;
};

export const MarginAccountSupplyAmountField = ({ name }: SupplyAmountFieldProps) => {
    const { control } = useFormContext();

    const { modalProps } = useModal();

    const {
        balance: userBalance,
        tokenSymbol,
        totalDeposited,
        totalDepositThreshold,
        decimals,
        poolBalance,
        apy,
    } = modalProps || {};

    const maxBalance = useMaxBalance();

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <SupplyInput<SupplyInputProps>
                    {...field}
                    setValue={(value) => field.onChange(value)}
                    userBalance={userBalance}
                    tokenSymbol={tokenSymbol}
                    poolBalance={poolBalance}
                    decimals={decimals}
                    totalDepositThreshold={totalDepositThreshold}
                    totalDeposited={totalDeposited}
                    disabled={Number(userBalance) === 0}
                    maxBalance={maxBalance}
                    tooltipText={`The annual percentage yield you earn from supplying assets to the pool. It adjusts based on the pool's usage and current interest rates.`}
                    label={
                        <>
                            <Text type={Text.types.Paragraph} className='text-content-tertiary'>
                                Supply APY
                            </Text>
                            <Text type={Text.types.Paragraph} fontWeight={Text.weights.SemiBold}>
                                {apy} %
                            </Text>
                        </>
                    }
                />
            )}
        />
    );
};
